import React from 'react';

function Quote(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11.375 5.125C11.7202 5.125 12 5.40482 12 5.75C12 6.09518 11.7202 6.375 11.375 6.375C8.25585 6.375 5.54721 8.13261 4.18547 10.7115C4.82943 10.3385 5.57729 10.125 6.375 10.125C8.79125 10.125 10.75 12.0838 10.75 14.5C10.75 16.9162 8.79125 18.875 6.375 18.875C3.95875 18.875 2 16.9162 2 14.5C2 9.32232 6.19732 5.125 11.375 5.125Z" />
      <path d="M21.375 5.125C21.7202 5.125 22 5.40482 22 5.75C22 6.09518 21.7202 6.375 21.375 6.375C18.2558 6.375 15.5472 8.13261 14.1855 10.7115C14.8294 10.3385 15.5773 10.125 16.375 10.125C18.7912 10.125 20.75 12.0838 20.75 14.5C20.75 16.9162 18.7912 18.875 16.375 18.875C13.9588 18.875 12 16.9162 12 14.5C12 9.32232 16.1973 5.125 21.375 5.125Z" />
    </svg>
  );
}

export default Quote;
